import styles from '../Footer.module.scss';

const FooterSection = props => (
  <div className={styles.footer__section}>{props.children}</div>
);

export default FooterSection;
